import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../lib/i18n";
import { useLang } from "../context/LanguageContext";

export function WhatsAppFAB() {
  const { lang, isRTL } = useLang();
  const label = lang === "ar" ? "تحدث معنا الآن" : "Chat with us now";

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label={label}
      className="fixed bottom-5 end-5 z-40 group flex items-center gap-3"
    >
      <span
        className={`hidden md:inline-block bg-white text-slate-800 text-xs font-semibold px-3 py-2 rounded-lg shadow-lg border border-slate-200 opacity-0 -translate-x-2 rtl:translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 whitespace-nowrap ${isRTL ? "order-2" : "order-1"}`}
      >
        {label}
      </span>
      <span className={`relative w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 transition-all ${isRTL ? "order-1" : "order-2"}`}>
        <MessageCircle className="w-7 h-7" />
        <span className="absolute -top-1 -end-1 w-3 h-3 bg-red-500 rounded-full animate-pulse" />
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-30 pointer-events-none" />
      </span>
    </a>
  );
}
